import { ErrorCode } from 'react-dropzone';

type FileRejectionMessageOptions = {
  formatsText: string;
  maxFileSizeMb: number;
};

export const getFileRejectionMessage = (
  code: ErrorCode | string,
  { formatsText, maxFileSizeMb }: FileRejectionMessageOptions,
) => {
  switch (code) {
    case ErrorCode.FileInvalidType:
      return `Unsupported format type. Please use ${formatsText}`;
    case ErrorCode.FileTooLarge:
      return `File size exceeds ${maxFileSizeMb} MB`;
    default:
      return 'Invalid file';
  }
};
